import { z } from 'zod';
import { UseSchema } from '../../common';

export const projectAccessControlPolicyAuthorizeDtoSchema = z.object({
  password: z.string().min(6).max(255).nullable().describe('Access control policy password'),
});

@UseSchema(projectAccessControlPolicyAuthorizeDtoSchema)
export class ProjectAccessControlPolicyAuthorizeDto {}
export interface ProjectAccessControlPolicyAuthorizeDto extends z.input<
  typeof projectAccessControlPolicyAuthorizeDtoSchema
> {}
